export function iconFromType(type: string, role: string, isCalc: boolean) {
  switch (type.toLowerCase()) {
    case 'boolean':
      return isCalc ? 'icon-boolean-discrete-calc' : 'icon-boolean-discrete';
    case 'number':
    case 'integer':
    case 'int':
    case 'bigint':
    case 'double precision':
    case 'double':
    case 'real':
    case 'float':
    case 'decimal':
    case 'fixed':
      return isCalc ? `icon-numeric-${role.toLowerCase()}-calc` : `icon-numeric-${role.toLowerCase()}`;
    case 'string':
    case 'character':
    case 'character varying':
    case 'varchar':
    case 'varchar2':
    case 'nvarchar2':
    case 'text':
      return isCalc ? 'icon-string-discrete-calc' : 'icon-string-discrete';
    case 'datetime':
    case 'date':
    case 'time':
    case 'timestamp with time zone':
    case 'timestamp':
    case 'timestamp without time zone':
      return isCalc ? `icon-date-${role.toLowerCase()}-calc` : `icon-date-${role.toLowerCase()}`;
    default:
      return 'icon-column-unknown';
  }
}
